import React, { ReactNode, useContext, useEffect, useState } from 'react';

import InternalUsersContext from '@totem/components/orgManagement/orgDetails/users/options/internalUsersContext';
import UserProfileContext from '@totem/components/userContext/UserProfileContext';
import { User } from '@totem/components/users/container/types';
import { API_V1 } from '@totem/utilities/endpoints';

type Props = {
  children?: ReactNode;
};

const InternalUsersContainer = ({ children }: Props) => {
  const { getApiToken } = useContext(UserProfileContext);
  const [data, setData] = useState<User[]>([]);
  const [searchTerm, setSearchTerm] = useState('');
  const [page, setPage] = useState<number>(0);
  const [pageSize, setPageSize] = useState<number>(50);
  const [refreshData, setRefreshData] = useState<boolean>(true);

  useEffect(() => {
    if (!refreshData) {
      return;
    }

    setRefreshData(false);

    if (searchTerm === '') {
      setData([]);
      return;
    }

    const payload = {
      page,
      pageSize,
      searchTerm,
    };

    fetch(`${API_V1}/internalUsers/search`, {
      method: 'POST',
      headers: new Headers({
        Authorization: `Bearer ${getApiToken()}`,
      }),
      body: JSON.stringify(payload),
    })
      .then((res) => res.json())
      .then((result: User[]) => {
        setData(result);
      });
  }, [refreshData]);

  const handleSetSearchTerm = (newSearchTerm: string) => {
    setSearchTerm(newSearchTerm);

    setPage(0);

    setRefreshData(true);
  };

  const handleSetPageSize = (newPageSize: number) => {
    setPageSize(newPageSize);

    setPage(0);

    setRefreshData(true);
  };

  return (
    <InternalUsersContext.Provider
      value={{
        searchTerm,
        page,
        pageSize,
        internalUsers: data,
        onRefresh: () => setRefreshData(true),
        setSearchTerm: handleSetSearchTerm,
        setPageSize: handleSetPageSize,
        setPage: (newPage: number) => setPage(newPage),
      }}
    >
      {children}
    </InternalUsersContext.Provider>
  );
};

export default InternalUsersContainer;
